import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomPriceRankDailyStatus_RoomPriceRankPage_Query } from "./query";

type Props = {
	hotelID: string;
	startDt: string;
	endDt: string;
};

export const useFetchRoomPriceRankDailyStatus = ({ hotelID, startDt, endDt }: Props) => {
	const { data, refetch } = useCustomSuspenseQuery(RoomPriceRankDailyStatus_RoomPriceRankPage_Query, {
		variables: { hotelID, startDt, endDt },
	});

	const onRefetch = useCallback(
		async (props: { hotelID: string; startDt: string; endDt: string }) => {
			return await refetch(props);
		},
		[refetch],
	);

	return {
		data,
		onRefetch,
	};
};
